import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ScopeVersion, StatusType } from '@app/core/model/scope-version'
import { ApprovalChecks } from '@app/features/scope-overview/model/approval-checks.interface'
import { PipesModule } from '@app/shared/pipe/index.module'
import { SharedModule } from '@app/shared/shared.module'
import { ApplicationSetting } from '@core/model/enums/application-setting.enum'
import { User } from '@core/model/user.model'

@Component({
  selector: 'scope-tooltip',
  standalone: true,
  imports: [CommonModule, PipesModule, SharedModule],
  templateUrl: './scope-tooltip.component.html',
  styleUrls: ['./scope-tooltip.component.scss'],
})
export class ScopeTooltipComponent {
  @Input() currentState!: StatusType
  @Input() currentUser!: User
  @Input() stateChecks!: ApprovalChecks
  @Input() set currentScope(value: ScopeVersion) {
    if (value) {
      const hasContent = (value.deliverables?.length || value.sections?.length || 0) > 0
      const total = value.getTotalSellingPrice()?.amount || 0
      this.isReadyToSubmit =
        value.status === StatusType.DRAFT &&
        value.identity.currentVersionNumber === value.version &&
        !value.containsUnmappedScopeMarkRoles &&
        hasContent &&
        total > 0
    }
  }

  @Output() onSubmitDraft = new EventEmitter()
  @Output() onWithdrawSubmission = new EventEmitter()
  @Output() onCompleteReview = new EventEmitter()
  @Output() onAgreeToScope = new EventEmitter()
  @Output() onDeclineScope = new EventEmitter()
  @Output() onAcceptScope = new EventEmitter()
  @Output() onRejectScope = new EventEmitter()
  @Output() onCloseScope = new EventEmitter()
  @Output() onOpenCreateChangeRequestModal = new EventEmitter()

  isReadyToSubmit: boolean

  submitDraft() {
    this.onSubmitDraft.emit()
  }

  withdrawSubmission() {
    this.onWithdrawSubmission.emit()
  }

  completeReviewSubmission() {
    this.onCompleteReview.emit()
  }

  agreeToScope() {
    this.onAgreeToScope.emit()
  }

  declineScope() {
    this.onDeclineScope.emit()
  }

  acceptScope() {
    this.onAcceptScope.emit()
  }

  rejectScope() {
    this.onRejectScope.emit()
  }

  closeScope() {
    this.onCloseScope.emit()
  }

  openCreateChangeRequestModal() {
    this.onOpenCreateChangeRequestModal.emit()
  }

  protected readonly ApplicationSetting = ApplicationSetting
}
